"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
class ValueTab extends fmko_ts_common_1.Widget {
    constructor(valueTabArgs) {
        super();
        this.element = document.createElement("button");
        this.tabContent = valueTabArgs.tabContent;
        this.tabName = valueTabArgs.tabName;
    }
    getValue() {
        return this.tabContent.getValue();
    }
    setValue(value, fireEvents) {
        return this.tabContent.setValue(value, fireEvents);
    }
    addValueChangeHandler(handler) {
        return this.tabContent.addValueChangeHandler(handler);
    }
    fireEvent(event) {
        return this.tabContent.fireEvent(event);
    }
    getTabName() {
        return this.tabName;
    }
    setTabName(name) {
        this.tabName = name;
    }
    getTabElement() {
        return this.element;
    }
    getContent() {
        return this.tabContent;
    }
}
exports.default = ValueTab;
//# sourceMappingURL=ValueTab.js.map